module.exports = __webpack_public_path__ + "static/img/progress_bg.121bd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bg.png
// module id = 3Gf9
// module chunks = 1